import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import "./Wallet.css";
import wallet_banner from "../../assets/wallet_banner.png";
import { Chip } from "@mui/material";
import { ApiCall, Colors } from "../../common/Const";
import arrow from "../../assets/arrow.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import moment from "moment";


const Wallet = () => {

    const user = useSelector((state) => state.auth.user);
  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  const[walletHistories , setWalletHistories]=useState([]);
    const [appsettings, setAppSettings] = useState([]);

  // const date = moment.now();

  console.log(user);
  const earnings = [
    {
      id: 1,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
    {
      id: 2,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
    {
      id: 3,
      date: "20.10.12",
      content: "Referal Earnings",
      coins: "50 coins",
    },
  ];

  const TotalEarn = () => {
    const walletParams = { customer_id: cusId };

    // console.log(walletParams);
    ApiCall("cwHistory", walletParams).then((data) => {
      if (data.message == "Success") {
        setWalletHistories(data.result);
      }
    });
  };
    useEffect(() => {
      ApiCall("appsetting").then((data) => {
        if (data.message == "Success") {
          setAppSettings(data.result);
          console.log(data.result);
        }
      });
    }, []);

  console.log(walletHistories);
  useEffect(()=>{

    TotalEarn();
  },[])
  return (
    <>
      <Header make={true} />
      <div className="Wallet">
        <div className=" container d-flex align-items-center justify-content-evenly wa-center">
          <div className="">
            <a
              href="javascript:history.go(-1)"
              style={{ textDecoration: "none" }}
            >
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: Colors.Base_color,
                  color: "white",
                }}
              >
                <div className="d-flex align-items-center gap-2 mx-2">
                  <i
                    class="fa-solid fa-caret-left"
                    style={{ fontSize: "18px" }}
                  ></i>
                  <span style={{ paddingTop: "1px" }}>Back</span>
                </div>
              </button>
            </a>
          </div>
          <span className="earnings_heading mx-2 justify-content-center">
            Wallet
          </span>
        </div>

        {/* <div className="banner_image image-fluid d-flex align-items-center"> */}
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-6 ">
              <div className="center_small_banner">
                <div className="d-flex flex-column align-items-center">
                  <span className="total_reward">Total Wallet Balance</span>
                  <span className="amount">
                    ₹{user ? user.wallet_amount : "0"}
                  </span>
                  <span className="last_credited">
                    Last Credited {walletHistories.last_credit} Coins
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        {/* <div className="Total-rewards"> */}
        <div className="container Total-rewards">
          {/* <div className="row justify-content-center align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-6 ">
              <div className="center_small_banner">
                <div className="d-flex flex-column align-items-center">
                  <span className="total_reward">Total Wallet Balance</span>
                  <span className="amount">
                    ₹{user ? user.wallet_amount : "0"}
                  </span>
                  <span className="last_credited">Last Credited {walletHistories.last_credit} Coins</span>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="row justify-content-center align-items-center text-center des">
            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-6">
              <span className="descri">
                for every{" "}
                <span style={{ color: "black" }}>
                  ${appsettings.amt_for_coin}
                </span>
                rs <span style={{ color: "black" }}>1 jeleso coins</span> can be
                credited on their user account,Refer a friend and get{" "}
                <span style={{ color: "black" }}>
                  ${appsettings.coin_for_amt}
                </span>
                rs.
              </span>
            </div>
          </div> */}
          <div className="row justify-content-center align-items-center text-center pb-5 pt-5">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-6">
              <div className="d-flex justify-content-between align-items-center">
                <span className="recent-earnings">Recent Converts</span>
                {/* <span className="recent-earnings">Recent Earnings</span> */}
                {/* <Chip
                  label="Coins"
                  icon={<ArrowDropDownIcon style={{color:'white'}} />}
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                    cursor: "pointer",
                    gap:3
                  }}
                 
                /> */}
                {/* <div className="d-flex justify-content-around align-items-center chip">
                  <span style={{ paddingRight: "5px" }}>Coins</span>
                  <ArrowDropDownIcon />
                </div> */}
              </div>
              <hr className="hr"></hr>
              {walletHistories.length != 0 && walletHistories.wallet_history
                ? walletHistories.wallet_history.map((items) => {
                    return (
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column earnings">
                          <span style={{ color: "#126a38" }}>
                            {items.details}({items.transaction_coin})coins
                          </span>
                          <small className="text-start dates">
                            {moment(items.date).format("YYYY/MM/DD")}
                          </small>
                        </div>
                        <span className="coinss" style={{ color: "#126a38" }}>
                          ₹{items.transaction_amount}
                        </span>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Wallet;
